import React, { Component } from "react";

import { MDBRow, MDBCol, MDBModal } from "mdbreact";

import { withTranslation } from "react-i18next";

import ViewVenues from "../../../components/NetworkMgmt/Venues/ViewVenues";

class ResidentSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            loading: false,
        };
    }

    toggleViewVenues = () => {
        this.setState({
            modalViewVenues: !this.state.modalViewVenues,
        });
    };

    toggleViewVenuePropMgmtGroups = () => {
        this.setState({
            modalViewVenuePropMgmtGroups:
                !this.state.modalViewVenuePropMgmtGroups,
        });
    };

    render() {
        return (
            <div>
                <MDBModal
                    isOpen={this.state.modalViewVenues}
                    toggle={this.toggleViewVenues}
                    className="form"
                    size="fluid"
                    centered
                >
                    <ViewVenues
                        venueList={this.props.venueList["VenueList"]}
                        toggleViewModifyVenues={this.toggleViewVenues}
                        updateName={this.props.updateName}
                        getVenueDetails={this.props.getVenueDetails}
                        venueRefreshTrigger={this.props.venueRefreshTrigger}
                        venueInfo={this.props.venueInfo}
                        loadingVenueDetails={this.props.loadingVenueDetails}
                        groupForm={this.props.groupForm}
                        keypoolForm={this.props.keypoolForm}
                        unitsArrayAll={this.props.unitsArrayAll}
                        keyPoolList={this.props.keyPoolList}
                        servicePlans={this.props.servicePlans}
                        staffArrayAll={this.props.staffArrayAll}
                        venueEquipList={this.props.venueEquipList}
                        keypoolID={this.props.keypoolID}
                        propMgmtID={this.props.propMgmtID}
                        optionTemplateVenues={this.props.optionTemplateVenues}
                        displayOptionIDGlobal={this.props.displayOptionIDGlobal}
                        optionTemplateDisplayOptions={this.props.optionTemplateDisplayOptions}
                    />
                </MDBModal>

                <div className="summaryCard">
                    <a href="#link" onClick={this.viewAllUnits}>
                        <h2>Subscribers</h2>
                    </a>
                    <div className="support rounded">
                        <MDBRow>
                            <MDBCol md="9">
                                <a href="#link">
                                    <p>Subscribers</p>
                                </a>
                            </MDBCol>
                            <MDBCol md="3">
                                <a href="#link">
                                    {" "}
                                    <p>
                                        {
                                            this.props.venueList[
                                                "PolicyCount_GlobalWirelessPlusLocalWiredAccess"
                                            ]
                                        }
                                    </p>
                                </a>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="9">
                                <p>Online Devices</p>
                            </MDBCol>
                            <MDBCol md="3">
                                <p>
                                    {this.props.venueList["OnlineDeviceCount"]}
                                </p>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="9">
                                <p>Devices connected in last week</p>
                            </MDBCol>
                            <MDBCol md="3">
                                <p>
                                    {this.props.venueList["DeviceCount"]}
                                </p>
                            </MDBCol>
                        </MDBRow>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ResidentSummary);
